import React, { useContext, useState, useCallback } from "react";
import { Grid, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useDropzone } from "react-dropzone";

// Contexts
import FacebookAdContext from "../../../../context/facebook_profiles/ad/AdContext";
import LayoutContext from "../../../../context/layout/LayoutContext";

// Components
import VideoSelection from "./VideoSelection";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: "0.5rem",
    paddingLeft: "0.5rem",
  },
  dropzone: {
    height: 120,
    backgroundColor: "#fafafa",
    borderStyle: "solid",
    borderStyle: "inset",
    borderWidth: 1,
    "&:focus": {
      outline: "none",
    },
    justifyContent: "center",
    alignItems: "center",
  },
  dropzoneError: {
    height: 120,
    backgroundColor: "#fafafa",
    borderStyle: "solid",
    borderWidth: 2,
    borderColor: theme.palette.error.main,
    "&:focus": {
      outline: "none",
    },
    justifyContent: "center",
    alignItems: "center",
  },
  helperText1: {
    textAlign: "center",
    color: "red",
  },
  helperText2: {
    textAlign: "center",
  },
  video: {
    "&:focus": {
      outline: "none",
    },
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
}));

const Video = () => {
  const classes = useStyles();

  const { uploadVideo, setVideoUrl, video_url, setVideoError, video_error } =
    useContext(FacebookAdContext);
  const { setAlert, clearAlerts } = useContext(LayoutContext);

  const [fileInputState, setFileInputState] = useState("");
  const [previewSource, setPreviewSource] = useState("");
  const [selectedFile, setSelectedFile] = useState("");
  const [browserOpen, setBrowserOpen] = useState(false);

  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];

    if (file) {
      let filename = file.name;

      // if (file.name.includes(".mp4")) {
      //   filename = file.name.replace(".mp4", "");
      // }

      clearAlerts();
      previewFile(file);
      setSelectedFile(file);
      setFileInputState(filename);

      setVideoUrl();
      setVideoError("Video is not selected or uploaded!");
    }
  }, []);

  const onDropRejected = useCallback(() => {
    setAlert("Video file only.", "error");
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    accept: "video/*",
    multiple: false,
    onDrop,
    onDropRejected,
  });

  const previewFile = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => setPreviewSource(reader.result);
  };

  const onUpload = (e) => {
    e.preventDefault();

    if (!selectedFile) return;

    const reader = new FileReader();
    reader.readAsDataURL(selectedFile);
    reader.onloadend = () => uploadVideo(reader.result, fileInputState);
  };

  const onBrowse = () => {
    setBrowserOpen(true);
  };

  const browserClose = () => {
    // No Video Selected
    setBrowserOpen(false);
  };

  const browserSave = (video_url, video_filename) => {
    // Video Selected
    setPreviewSource(video_url);
    setFileInputState(video_filename);

    setVideoUrl(video_url);
    setVideoError();
    browserClose();
  };

  return (
    <Grid container item xs={7} className={classes.root}>
      <VideoSelection
        browserOpen={browserOpen}
        browserClose={browserClose}
        browserSave={browserSave}
      />
      <Grid item xs={5}>
        <Grid
          item
          container
          className={video_error ? classes.dropzoneError : classes.dropzone}
          {...getRootProps()}
        >
          {previewSource ? (
            <video
              height="120"
              width="100%"
              controls
              src={previewSource}
              className={classes.video}
            />
          ) : (
            <Grid item className={classes.helperText2}>
              <input {...getInputProps()} />{" "}
              <Typography variant="body1"> VIDEO </Typography>{" "}
              <Typography variant="overline">
                Drag and drop file here <br />
                or click to select file{" "}
              </Typography>{" "}
            </Grid>
          )}{" "}
        </Grid>{" "}
      </Grid>
      <Grid item xs={7} container justifyContent="space-evenly" alignItems="center">
        <Grid item xs={12}>
          <Typography variant="body2" className={classes.helperText1}>
            {" "}
            {video_error ? (
              video_error
            ) : previewSource ? (
              "Drag and drop file into the box to replace the video."
            ) : (
              <span> & emsp; </span>
            )}{" "}
          </Typography>
          <Typography variant="body1" className={classes.helperText2}>
            {" "}
            {fileInputState ? (
              <span>
                File name: <strong> {fileInputState} </strong>{" "}
              </span>
            ) : (
              <span> & emsp; </span>
            )}{" "}
          </Typography>{" "}
        </Grid>
        <Grid item xs={4}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={onBrowse}
          >
            Browse{" "}
          </Button>{" "}
        </Grid>
        <Grid item xs={4}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={onUpload}
            disabled={previewSource ? (video_url ? true : false) : true}
          >
            Upload{" "}
          </Button>{" "}
        </Grid>{" "}
      </Grid>{" "}
    </Grid>
  );
};

export default Video;
